import { get, post } from './http';

// 账号密码登录，返回 { userId, accessToken, refreshToken, expiresTime }
export const login = data => post('/system/auth/login', data);

// 登出
export const logout = () => post('/system/auth/logout');

// 获取登录用户的权限信息
export const getPermissionInfo = () => get('/system/auth/get-permission-info');
